import { BaseFiltersInput } from "@core/store/types/common/statistic/generic/statisticFilters";
import { ReferralService } from "@core/services/admin/finances/referral/referralService";
import { Admin } from "@core/store/types/admin/users/webmasters/WebmastersState";
import { Filters } from "@core/store/modules/common/generators/filters";

class ReferralList extends Filters<Admin, BaseFiltersInput> {
  getData = async (offset: number, limit: number, filters: BaseFiltersInput) => {
    const { data: { webmasters } } = await ReferralService.getWebmastersFilters(limit, offset, { isReferral: true, ...filters });
    return {
      data: {
        items: webmasters.items,
        count: webmasters?.count
      }
    };
  }
  
  getInitialFilters = (ids?: string): { referral: string } | undefined => {
    if (ids) {
      const referral = ids;
      return { referral };
    }
  };
}

export const referralList = new ReferralList();
